import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberAbs'
})
export class NumberAbsPipe implements PipeTransform {

  transform(value: any): any {
    if (value !== 0 && value !== null) {            
        return Math.abs(value);
    } else {
      return '-';
    }
  }

}
